export function extractEmailFromJWT(token: string): string | null {
  try {
    // Split the JWT into parts
    const parts = token.split(".")
    if (parts.length !== 3) {
      return null
    }

    // Decode the payload (second part)
    const payload = parts[1]
    const decodedPayload = atob(payload)
    const payloadObj = JSON.parse(decodedPayload)

    // Extract email from the path field
    if (payloadObj.path && typeof payloadObj.path === "string") {
      // Format appears to be "orgId/someId/email"
      const pathParts = payloadObj.path.split("/")
      if (pathParts.length >= 3) {
        return pathParts[2] // The email is the third part
      }
    }

    return null
  } catch (error) {
    return null
  }
}

export function formatOtpLoginUrl(email: string, token: string): string {
  const baseUrl = window.location.origin
  const params = new URLSearchParams({
    email,
    token,
  })
  return `${baseUrl}/login/otp?${params.toString()}`
}
